import React, { Component } from 'react';
import QrReader from 'react-qr-reader';
// import QrReader from 'react-qr-scanner';
import audio from './assets/scanned.mp3';
import { ReactComponent as ScannerImg } from './assets/scanner.svg';
import { ReactComponent as CameraImg } from './assets/camera.svg';

class Scanner extends Component {
    state = {
        result: 'No result',
        size: 90,
        cameraType: 'environment',
    }

    handleScan = data => {
        if (data) {
            this.audio.play()
            this.setState({
                result: data
            });
            this.props.removeItem(data, 'decrement');
        }
    }

    handleError = err => {
        console.error(err)
    }

    sizeHandler = () => {
        this.setState({ size: this.rangeValue.value });
    }

    cameraHandler = (value) => {
        const scannerParent = this.scannerRef.parentNode;
        const cameraParent = this.cameraRef.parentNode;
        if (value === 'user') {
            this.scannerRef.style.fill = '#28a745';
            this.cameraRef.style.fill = '#fff';
            cameraParent.classList.add('active');
            scannerParent.classList.remove('active');
        } else {
            this.scannerRef.style.fill = '#fff';
            this.cameraRef.style.fill = '#28a745';
            cameraParent.classList.remove('active');
            scannerParent.classList.add('active');
        }
        console.log(value);
        this.setState({ cameraType: value });
    }

    render() {
        console.log(this.state);

        return (
            <div className="container text-center" id="scanner-section">
                <audio src={audio} hidden ref={ref => this.audio = ref}></audio>
                <button
                    className="btn btn-outline-success active mr-3 btn-sm"
                    onClick={() => this.cameraHandler('environment')}
                    style={{fontSize: '12px'}}
                >
                    <ScannerImg
                        ref={ref => this.scannerRef = ref}
                        width="30"
                        fill="#fff"
                        height="30"
                    />
                    <span className="ml-2">Scanner</span>
                </button>
                <button
                    className="btn btn-outline-success btn-sm"
                    onClick={() => this.cameraHandler('user')}
                    style={{fontSize: '12px'}}
                >
                    <CameraImg
                        width="30"
                        fill="#28a745"
                        ref={ref => this.cameraRef = ref}
                    />
                    <span className="ml-2">Camera</span>
                </button>
                <div className="form-group">
                    <input
                        type="range"
                        min="20"
                        max="100"
                        ref={ref => this.rangeValue = ref}
                        onChange={this.sizeHandler}
                        className="form-control"
                        style={{ maxWidth: '300px', margin: 'auto' }}
                    />
                </div>
                <div className="qr-wrapper" style={{ width: this.state.size + '%', margin: 'auto' }}>
                    <QrReader
                        delay={3000}
                        onError={this.handleError}
                        onScan={this.handleScan}
                        style={{ width: '100%' }}
                        facingMode={this.state.cameraType}
                    />
                </div>


                <p>{this.state.result}</p>
            </div >
        )
    }
}

export default Scanner;